/**
 *  Formats a school year input into a concise string representation.
 *
 * @param {*} input- The school year to format. Can be a single year as a number (e.g., 2007) or a range as a string in the format "YYYY–YYYY" (e.g., "2007–2008").
 * @returns {string} - The formatted school year string.
 * - If the input is a single year: "2007" → "2007–08"
 * - If the input is a range in the same century: "2007–2008" → "2007–08"
 * - If the input crosses centuries: "1999–2000" → "1999–2000"
 * - If the input is invalid or unprocessable, it returns the input as a string.
 */
export const formatSchoolYear = (input) => {
    let startYear, endYear;

    // If input is a number, calculate the school year range
    if (typeof input === 'number') {
        startYear = input;
        endYear = input + 1;
    }

    // If input is a string in the format "YYYY–YYYY", parse it
    if (typeof input === 'string' && input.includes('–')) {
        [startYear, endYear] = input.split('–').map(Number);
    }

    // If both startYear and endYear are valid, format the range
    if (startYear && endYear) {
        if (Math.floor(startYear / 100) === Math.floor(endYear / 100)) {
            return `${startYear}–${endYear.toString().slice(-2)}`;
        } else {
            return `${startYear}–${endYear}`;
        }
    }

    // If input couldn't be processed, return it as-is
    return input.toString();
};
